import { createWsConnectionSlice } from '@skynet/data-ws-core';
import { smmActions } from './actions';

const wsSmmSlice = createWsConnectionSlice('wsSmm', smmActions);

export type WsSmmState = ReturnType<typeof wsSmmSlice.getInitialState>;

export const wsSmmActions = wsSmmSlice.actions;

export default wsSmmSlice.reducer;
